export default __webpack_public_path__ + "static/sun-chasers-desktop-caf7b087f5822cf7a38fed0e5d90a1fa.webp";